<!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
<script setup>
import { computed } from 'vue';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

// Card "Alteração de preço": contato do proprietário e edição do valor
// sugerido do imóvel selecionado no relatório.
const props = defineProps({
  modelValue: { type: String, default: '' },
  owner: { type: Object, default: () => ({}) },
  isRental: { type: Boolean, default: false },
  validationMessage: { type: String, default: '' },
  isSaving: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
});

const emit = defineEmits(['update:modelValue', 'save']);

const ownerContactRows = computed(() =>
  [
    {
      icon: 'i-lucide-user',
      label: '',
      value: props.owner.name,
    },
    {
      icon: 'i-lucide-phone',
      label: 'Telefone',
      value: props.owner.phone,
    },
    {
      icon: 'i-lucide-mail',
      label: 'E-mail',
      value: props.owner.email,
    },
  ].filter(row => row.value)
);

const priceEditQuestion = computed(() =>
  props.isRental
    ? 'Por quanto o imóvel será alugado?'
    : 'Por quanto o imóvel será vendido?'
);
</script>

<template>
  <!-- eslint-disable vue/no-bare-strings-in-template, @intlify/vue-i18n/no-raw-text -->
  <LaisCard title="Alteração de preço">
    <div
      class="rounded-lais-sm border border-lais-gold/40 bg-lais-gold/10 px-3 py-2 text-[13px] leading-relaxed text-lais-text-body"
    >
      <p class="font-semibold text-lais-text">
        Alterações feitas aqui são somente para a Imudei
      </p>
      <p class="mt-1">
        Caso queira alterar em todos os seus canais faça esse ajuste diretamente
        no seu CRM.
      </p>
    </div>

    <div v-if="ownerContactRows.length" class="mt-4">
      <h3 class="font-redHatDisplay text-[16px] font-semibold text-lais-text">
        Dados do proprietário
      </h3>
      <div class="mt-3 grid gap-3">
        <div
          v-for="row in ownerContactRows"
          :key="`${row.label}-${row.value}`"
          class="flex items-start gap-3"
        >
          <span
            class="mt-0.5 size-4 shrink-0 text-lais-primary"
            :class="row.icon"
            aria-hidden="true"
          />
          <div class="min-w-0">
            <p
              v-if="row.label"
              class="text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
            >
              {{ row.label }}
            </p>
            <p class="break-words text-[13px] font-semibold text-lais-text">
              {{ row.value }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <label
      class="mt-4 block text-[11px] font-semibold uppercase tracking-wide text-lais-text-muted"
    >
      {{ priceEditQuestion }}
    </label>
    <div class="mt-2 flex flex-col gap-2 sm:flex-row">
      <input
        :value="modelValue"
        inputmode="numeric"
        placeholder="Valor inteiro"
        class="h-10 min-w-0 flex-1 rounded-lais border border-lais-border bg-white px-3 text-[14px] text-lais-text focus:border-lais-primary focus:outline-none"
        @input="emit('update:modelValue', $event.target.value)"
      />
      <LaisPrimaryButton
        icon="i-lucide-save"
        :is-loading="isSaving"
        :disabled="disabled"
        @click="emit('save')"
      >
        Salvar
      </LaisPrimaryButton>
    </div>
    <p
      v-if="validationMessage"
      class="mt-2 text-[12px] font-semibold text-lais-danger"
    >
      {{ validationMessage }}
    </p>
    <p class="mt-3 text-[12px] text-lais-text-muted">
      Acha que esse imóvel precisa de um ajuste no preço sugerido? Edite o valor
      sugerido.
    </p>
  </LaisCard>
</template>
